import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AddressSuggestion {
  placeId: string;
  description: string;
  city?: string;
}

export interface DistanceResult {
  distance: number;
  durationSeconds: number;
  address: string;
}

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private apiUrl = '/api/Address';

  constructor(private http: HttpClient) {}

  searchAddress(query: string): Observable<AddressSuggestion[]> {
    return this.http.get<AddressSuggestion[]>(`${this.apiUrl}/search`, {
      params: { query }
    });
  }

  calculateDistance(address: string): Observable<DistanceResult> {
    return this.http.post<DistanceResult>(`${this.apiUrl}/calculate-distance`, {
      address
    });
  }
}
